module.exports = __webpack_public_path__ + "static/img/二维码.752d802b.png";